export default {"src":"/_next/static/media/coqui.1f30ed5b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};